import React from 'react';
import Crystal from 'components/crystal';

function index() {
  return <Crystal />;
}

export default index;
